export enum IdpOauth2AuthorizeAction {
    REGISTER = 'register',
    SIGN_IN = 'signIn'
}
